export default __webpack_public_path__ + "static/media/IMG_0702 copie.7f06f8e9.jpg";